export const TELEGRAM_BOT_URL = 'https://t.me/EachJewelryBot';
export const INSTAGRAM_URL = 'https://www.instagram.com/each_jewelry/';
export const FACEBOOK_URL = 'https://www.facebook.com/eachjewelry';
export const TWITTER_URL = 'https://x.com/EachJewelry';
export const WHATSAPP_URL = 'https://wa.me/13072208099';
